import React from 'react';
import {Text} from '@gs-ux-uitoolkit-react/text';

export function QuoteMediaDisclosure() {
    return (
        <div className="pt-6 mt-6 border-t border-gray-20 w-full">
            <Text className="text-gray-70" typography="textBody04Regular">
                Financial Market Data powered
                by <a href="https://www.quotemedia.com/" target="_blank" className="text-blue-60">Quotemedia.com</a> and <a href="https://www.quodd.com" target="_blank" className="text-blue-60">Xignite</a>.
                All rights reserved. <a href="https://quotemedia.com/legal/tos" target="_blank" className="text-blue-60">View the Terms of Use.</a> Data delayed 15 minutes, unless otherwise indicated.
                The Dow Jones Average℠ is compiled, calculated, and distributed by Dow Jones & Company, Inc., and has been licensed for use. All content of The Dow Jones Averages℠ ©2024 Dow Jones & Company, Inc. All Rights Reserved.
                Folio Financial, Inc., its affiliates, and its data and content providers are not liable for any errors or delays in quotes and other content or for any actions you take in reliance on this data or information. By using this data you are agreeing to the <a
                href="https://www.spglobal.com/en/terms-of-use/" target="_blank" className="text-blue-60">S&P Dow Jones Indices, LLC Terms of Use</a> and the <a href="https://www.otcmarkets.com/terms-of-service" target="_blank" className="text-blue-60">Pink OTC Markets Terms of Use</a>, where applicable.
            </Text>
        </div>
    );
}

